// Based on formatUnicorn used by StackOverflow
const formatDoubleBraces = (str, replacements) => {
	let formattedStr = str;

	if (replacements) {
		Object.keys(replacements).forEach(function (key) {
			formattedStr = formattedStr.replace(
				new RegExp(`{{${key}}}`, 'gi'),
				replacements[key],
			);
		});
	}

	return formattedStr;
};

export default formatDoubleBraces;
